export const defaultOptions = [
  "None Not at all",
  "Slight Rare, less than a day or two",
  "Mild Several days",
  "Moderate More than half the days",
  "Severe Nearly every day"
];

// export const teenQuestions_Level1 = [
//   {
//     id: 0,
//     question: "Which country are you in?",
//     options: [
//       "India",
//       "Indonesia",
//       "Australia",
//       "Afganistan",
//       "Algeria",
//       "Bermuda",
//       "Zimbabwe",
//     ],
//     inputType: "select",
//     category: "demographic",
//     scores: [0, 0, 0, 0, 0, 0, 0],
//   },
//   {
//     id: 1,
//     question: "How often do you feel overwhelmed with school work?",
//     options: defaultOptions,
//     inputType: "radio",
//     category: "academic_stress",
//     scores: [0, 1, 2, 3, 4],
//   },
//   {
//     id: 1,
//     question: "How often do you feel Depressed?",
//     options: defaultOptions,
//     inputType: "radio",
//     category: "depression",
//     scores: [0, 1, 2, 3, 4],
//   },
//   {
//     id: 1,
//     question: "How often do you feel anxious?",
//     options: defaultOptions,
//     inputType: "radio",
//     category: "anxiety",
//     scores: [0, 1, 2, 3, 4],
//   },
//   // Add more teen-specific level 1 questions...
// ];

export const teenLevel1Questions = [
  {
    id: 0,
    question: "Which country are you in?",
    options: [
      "India",
      "Indonesia",
      "Australia",
      "Afganistan",
      "Algeria",
      "Bermuda",
      "Zimbabwe",
    ],
    inputType: "select",
    category: "demographic",
    scores: [0, 0, 0, 0, 0, 0, 0],
  },
  {
    id: "1",
    question: "Do you often feel unwell or in pain, even when nothing seems wrong?",
    options: defaultOptions,
    inputType: "radio",
    category: "physical",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "2",
    question: "Do you worry a lot about your health or think something bad might happen to your body?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "3",
    question: "Do you have trouble falling asleep or staying asleep, even when you’re really tired?",
    options: defaultOptions,
    inputType: "radio",
    category: "sleep",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "4",
    question: "Do you stay up late and still feel full of energy the next day?",
    options: defaultOptions,
    inputType: "radio",
    category: "attention",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "5",
    question: "Do you find it hard to focus in class, when reading, doing homework, or even playing games??",
    options: defaultOptions,
    inputType: "radio",
    category: "mood",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "6",
    question: "Do things that used to be fun now feel boring or not enjoyable anymore?",
    options: defaultOptions,
    inputType: "radio",
    category: "mood",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "7",
    question: "Do you feel down or really sad for long periods of time, even when nothing specific happened?",
    options: defaultOptions,
    inputType: "radio",
    category: "irritability",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "8",
    question: "Do you feel more annoyed or irritated than usual, even over small things?",
    options: defaultOptions,
    inputType: "radio",
    category: "anger",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "9",
    question: "Do you get angry easily or lose your temper quickly?",
    options: defaultOptions,
    inputType: "radio",
    category: "impulsivity",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "10",
    question: "Do you start a lot of things at once or take risks without thinking, more than you usually do?",
    options: defaultOptions,
    inputType: "radio",
    category: "sleep",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "11",
    question: "Do you often feel nervous, anxious, or scared, even when you’re not sure why?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "12",
    question: "Do you get stuck worrying and find it hard to stop?",
    options: defaultOptions,
    inputType: "radio",
    category: "anxiety",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "13",
    question: "Do you avoid doing things because they make you feel nervous or uncomfortable?",
    options: defaultOptions,
    inputType: "radio",
    category: "avoidance",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "14",
    question: "Have you ever heard voices talking about you or telling you things when no one was there?",
    options: defaultOptions,
    inputType: "radio",
    category: "psychosis",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "15",
    question: "Have you seen things that other people couldn’t see, even though you were fully awake?",
    options: defaultOptions,
    inputType: "radio",
    category: "psychosis",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "16",
    question: "Do you get scary or upsetting thoughts that keep coming into your mind, even if you don’t want them?",
    options: defaultOptions,
    inputType: "radio",
    category: "intrusiveThoughts",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "17",
    question: "Do you get worried that things you touch might be dirty or harmful?",
    options: defaultOptions,
    inputType: "radio",
    category: "ocd",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "18",
    question: "Have you used alcohol, tobacco, or drugs to help you cope with stress or how you’re feeling?",
    options: defaultOptions,
    inputType: "radio",
    category: "ocd",
    scores: [0, 1, 2, 3, 4],
  },
  {
    id: "19",
    question: "Have you ever hidden or lied about using these from your family, teachers, or friends?",
    options: defaultOptions,
    inputType: "radio",
    category: "ocd",
    scores: [0, 1, 2, 3, 4],
  }
];

export const teen_Level2Questions = {
  depression: [
    {
      id: "0",
      question: "Have you felt like you’re not good enough or that you’ve let people down?",
      options: defaultOptions,
      inputType: "radio",
      category: "depression",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: "0",
      question: "Have you avoided friends, family, or activities you usually enjoy?",
      options: defaultOptions,
      inputType: "option",
      category: "depression",
      scores: [0, 1, 2, 3, 4],
    }
  ],
  anxiety: [
    {
      id: "0",
      question: "Have you worried a lot about the future or about something bad happening?",
      options: defaultOptions,
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: "1",
      question: "Have you felt panicky or had sudden feelings of fear for no clear reason?",
      options: defaultOptions,
      inputType: "radio",
      category: "anxiety",
      scores: [0, 1, 2, 3, 4],
    }

  ],
  mania: [
    {
      id: "0",
      question: "Have you felt unusually excited or full of energy, even when you hadn’t slept much?",
      options: defaultOptions,
      inputType: "radio",
      category: "mania",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: "1",
      question: "Have you started doing a lot of new things all at once or taken risks without thinking?",
      options: defaultOptions,
      inputType: "radio",
      category: "mania",
      scores: [0, 1, 2, 3, 4],
    }
  ],
  anger: [
    {
      id: "teen_lvl2_anger_1",
      question: "Have you found yourself getting angry more quickly than usual?",
      options: defaultOptions,
      inputType: "radio",
      category: "anger",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: "teen_lvl2_anger_2",
      question: "Have you had trouble calming down after getting upset or frustrated?",
      options: defaultOptions,
      inputType: "radio",
      category: "anger",
      scores: [0, 1, 2, 3, 4],
    }
  ],
  sleep: [
    {
      id: "0",
      question: "Have you had trouble falling asleep, staying asleep, or waking up too early?",
      options: defaultOptions,
      inputType: "radio",
      category: "sleep",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: "1",
      question: "Have you slept much more or less than usual but still felt tired?",
      options: defaultOptions,
      inputType: "radio",
      category: "sleep",
      scores: [0, 1, 2, 3, 4],
    }
  ],
  somaticSymptoms: [
    {
      id: "0",
      question: "Have you had frequent headaches, stomachaches, or other physical pains without a clear cause?",
      options: defaultOptions,
      inputType: "radio",
      category: "somaticSymptoms",
      scores: [0, 1, 2, 3, 4],
    },
    {
      id: "1",
      question: "Have you visited the nurse or asked to go home from school because of feeling sick, even when not physically ill?",
      options: defaultOptions,
      inputType: "radio",
      category: "somaticSymptoms",
      scores: [0, 1, 2, 3, 4],
    }
  ],
  thoughtsAndBehaviors:[
{
  id: "0",
  question: "Have you had thoughts that life isn’t worth living or that you’d be better off gone?",
  options: defaultOptions,
  inputType: "radio",
  category: "thoughtsAndBehaviors",
    scores: [0, 1, 2, 3, 4],
},
{
  id: "1",
  question: "Have you felt like you're losing touch with reality or seeing/hearing things that others don’t?",
  options: defaultOptions,
  inputType: "radio",
  category: "thoughtsAndBehaviors",
    scores: [0, 1, 2, 3, 4],
}
  ],
  substanceUse:[
    {
  id: "0",
  question: "Have you used alcohol, cigarettes, or drugs to help deal with your feelings or stress?",
  options: defaultOptions,
  inputType: "radio",
  category: "substanceUse",
    scores: [0, 1, 2, 3, 4],
},
{
  id: "1",
  question: "Have you hidden or lied about using substances from parents, teachers, or friends?",
  options: defaultOptions,
  inputType: "radio",
  category: "substanceUse",
    scores: [0, 1, 2, 3, 4],
}
  ]
}

// Add teen level 2 questions
// export const teenLevel2Questions = {
//   anxiety: [
//     {
//       id: 0,
//       question: "How does anxiety affect your school performance?",
//       options: defaultOptions,
//       inputType: "radio",
//       category: "anxiety",
//       scores: [0, 1, 2, 3, 4],
//     },
//     // ... more questions
//   ],
//   depression: [
//     {
//       id: 0,
//       question: "How often do you feel isolated from your peers?",
//       options: defaultOptions,
//       inputType: "radio",
//       category: "depression",
//       scores: [0, 1, 2, 3, 4],
//     },
//     // ... more questions
//   ],
//   // Add other categories as needed
// };

export const categoryThresholds = {
  anxiety: 4,
  depression: 4,
  anger: 4,
  mania: 4,
  sleep: 4,
  // Add other categories as needed
};